import getCookieValue from 'util/getCookie';
import { SESSION_ID_COOKIE_NAME } from './constants';

export let authToken: string | undefined = getCookieValue(SESSION_ID_COOKIE_NAME);
export const setAuthToken = (token?: string) => {
  authToken = token;
};
